import { initializeSvelteComponent } from "@src/svelte-component"

import Editor from "@src/components/editor/Editor.svelte"

initializeSvelteComponent("Editor", Editor)
